(function () {
  "use strict";

  // ---------- config ----------
  let COLS = 8;
  let BASE_ADDR = 0xD000;

  let rows = 10;
  let totalDiffs = 4;
  let livesInit = 2;
  let ROUND_MS = 40000; // overridden by the round-time slider at each run start

  // ---------- dom refs ----------
  let imageARowsEl = document.getElementById("imageA-rows");
  let imageBRowsEl = document.getElementById("imageB-rows");

  let statusTag = document.getElementById("status-tag");
  let foundTag = document.getElementById("found-tag");
  let strikesTag = document.getElementById("strikes-tag");
  let ttlFill = document.getElementById("ttl-fill");
  let ttlTag = document.getElementById("ttl-tag");

  let splashScreen = document.getElementById("splash-screen");
  let winScreen = document.getElementById("win-screen");
  let loseScreen = document.getElementById("lose-screen");
  let loseMessage = document.getElementById("lose-message");

  let startBtn = document.getElementById("start-btn");
  let winRetryBtn = document.getElementById("win-retry-btn");
  let loseRetryBtn = document.getElementById("lose-retry-btn");

  let rowsSlider = document.getElementById("rows");
  let rowsValueEl = document.getElementById("rows-value");
  let diffsSlider = document.getElementById("diffs");
  let diffsValueEl = document.getElementById("diffs-value");
  let livesSlider = document.getElementById("lives");
  let livesValueEl = document.getElementById("lives-value");
  let roundTimeSlider = document.getElementById("round-time");
  let roundTimeValueEl = document.getElementById("round-time-value");

  // ---------- state ----------
  let running = false;
  let dataA = [];          // rows x COLS of "XX" hex strings
  let dataB = [];
  let diffSet = new Set(); // keys "r-c" that are actually different
  let foundSet = new Set();
  let cursorRow = 0;
  let cursorCol = 0;
  let lives = 2;
  let startTime = null;
  let lastFrame = null;
  let rafId = null;
  let byteCellsA = []; // [row][col] -> element reference for Image A
  let byteCellsB = []; // [row][col] -> element reference for quick class toggling

  function randHex() {
    return Math.floor(Math.random() * 256).toString(16).toUpperCase().padStart(2, "0");
  }

  function formatTime(ms) {
    let totalSec = Math.max(0, ms) / 1000;
    let m = Math.floor(totalSec / 60);
    let s = totalSec - m * 60;
    return String(m).padStart(2, "0") + ":" + s.toFixed(1).padStart(4, "0");
  }

  // ---------- config labels ----------
  function formatRoundTime(totalSeconds) {
    let m = Math.floor(totalSeconds / 60);
    let s = totalSeconds % 60;
    return String(m).padStart(2, "0") + ":" + String(s).padStart(2, "0");
  }

  function updateRoundTimeLabel() {
    roundTimeValueEl.textContent = formatRoundTime(parseInt(roundTimeSlider.value, 10));
  }
  function updateRowsLabel() { rowsValueEl.textContent = rowsSlider.value; }
  function updateDiffsLabel() { diffsValueEl.textContent = diffsSlider.value; }
  function updateLivesLabel() { livesValueEl.textContent = livesSlider.value; }

  roundTimeSlider.addEventListener("input", updateRoundTimeLabel);
  rowsSlider.addEventListener("input", updateRowsLabel);
  diffsSlider.addEventListener("input", updateDiffsLabel);
  livesSlider.addEventListener("input", updateLivesLabel);

  function readConfig() {
    rows = parseInt(rowsSlider.value, 10);
    totalDiffs = parseInt(diffsSlider.value, 10);
    livesInit = parseInt(livesSlider.value, 10);
    ROUND_MS = parseInt(roundTimeSlider.value, 10) * 1000;
  }

  function setSlidersDisabled(disabled) {
    roundTimeSlider.disabled = disabled;
    rowsSlider.disabled = disabled;
    diffsSlider.disabled = disabled;
    livesSlider.disabled = disabled;
  }

  // ---------- data generation ----------
  function generateData() {
    dataA = [];
    dataB = [];
    diffSet = new Set();
    foundSet = new Set();

    for (let r = 0; r < rows; r++) {
      let rowA = [];
      for (let c = 0; c < COLS; c++) {
        rowA.push(randHex());
      }
      dataA.push(rowA);
      dataB.push(rowA.slice());
    }

    let cellCount = rows * COLS;
    let maxDiffs = Math.min(totalDiffs, cellCount);
    while (diffSet.size < maxDiffs) {
      let rr = Math.floor(Math.random() * rows);
      let cc = Math.floor(Math.random() * COLS);
      let key = rr + "-" + cc;
      if (diffSet.has(key)) continue;
      diffSet.add(key);

      let original = dataA[rr][cc];
      let replacement;
      do {
        replacement = randHex();
      } while (replacement === original);
      dataB[rr][cc] = replacement;
    }
    totalDiffs = maxDiffs; // in case rows*COLS was smaller than requested
  }

  // ---------- rendering ----------
  function addrLabel(rowIndex) {
    return "0x" + (BASE_ADDR + rowIndex * COLS).toString(16).toUpperCase().padStart(4, "0");
  }

  function renderGrids() {
    imageARowsEl.innerHTML = "";
    imageBRowsEl.innerHTML = "";
    byteCellsA = [];
    byteCellsB = [];

    for (let r = 0; r < rows; r++) {
      let rowAEl = document.createElement("div");
      rowAEl.className = "mem-row";
      let addrAEl = document.createElement("span");
      addrAEl.className = "addr";
      addrAEl.textContent = addrLabel(r);
      rowAEl.appendChild(addrAEl);

      let rowBEl = document.createElement("div");
      rowBEl.className = "mem-row";
      let addrBEl = document.createElement("span");
      addrBEl.className = "addr";
      addrBEl.textContent = addrLabel(r);
      rowBEl.appendChild(addrBEl);

      let cellRowA = [];
      let cellRowB = [];
      for (let c = 0; c < COLS; c++) {
        let byteA = document.createElement("span");
        byteA.className = "byte";
        byteA.textContent = dataA[r][c];
        rowAEl.appendChild(byteA);
        cellRowA.push(byteA);

        let byteB = document.createElement("span");
        byteB.className = "byte";
        byteB.textContent = dataB[r][c];
        rowBEl.appendChild(byteB);
        cellRowB.push(byteB);
      }
      byteCellsA.push(cellRowA);
      byteCellsB.push(cellRowB);

      imageARowsEl.appendChild(rowAEl);
      imageBRowsEl.appendChild(rowBEl);
    }
  }

  function refreshCursorVisual(prevRow, prevCol) {
    if (prevRow !== undefined && byteCellsB[prevRow] && byteCellsB[prevRow][prevCol]) {
      byteCellsB[prevRow][prevCol].classList.remove("cursor");
    }
    byteCellsB[cursorRow][cursorCol].classList.add("cursor");
  }

  // ---------- game flow ----------
  function setStatus(text, cls) {
    statusTag.textContent = text;
    statusTag.classList.remove("running", "failed", "cleared");
    if (cls) statusTag.classList.add(cls);
  }

  function resetGame() {
    readConfig();
    generateData();
    renderGrids();

    cursorRow = 0;
    cursorCol = 0;
    byteCellsB[cursorRow][cursorCol].classList.add("cursor");

    lives = livesInit;
    startTime = null;
    lastFrame = null;
    running = true;

    setStatus("BREACHING", "running");
    foundTag.textContent = "FOUND 0/" + totalDiffs;
    strikesTag.textContent = "STRIKES LEFT " + lives;
    ttlFill.style.width = "100%";
    ttlTag.textContent = "TTL " + formatTime(ROUND_MS);

    splashScreen.classList.add("hidden");
    winScreen.classList.add("hidden");
    loseScreen.classList.add("hidden");
    setSlidersDisabled(true);

    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(gameLoop);
  }

  function endGame(won, reason) {
    running = false;
    if (rafId) cancelAnimationFrame(rafId);
    setSlidersDisabled(false);

    if (won) {
      setStatus("ACCESS GRANTED", "cleared");
      winScreen.classList.remove("hidden");
    } else {
      setStatus("BREACH FAILED", "failed");
      if (reason === "time") {
        loseMessage.textContent = "The connection timed out before every altered byte was found.";
      } else {
        loseMessage.textContent = "Out of strikes — the firewall flagged the intrusion.";
      }
      loseScreen.classList.remove("hidden");
    }
  }

  function gameLoop(timestamp) {
    if (!running) return;

    if (startTime === null) {
      startTime = timestamp;
      lastFrame = timestamp;
    }
    lastFrame = timestamp;

    let elapsed = timestamp - startTime;
    let remaining = ROUND_MS - elapsed;

    let pct = Math.max(0, (remaining / ROUND_MS) * 100);
    ttlFill.style.width = pct + "%";
    ttlTag.textContent = "TTL " + formatTime(Math.max(0, remaining));

    if (remaining <= 0) {
      endGame(false, "time");
      return;
    }

    rafId = requestAnimationFrame(gameLoop);
  }

  // ---------- input ----------
  function moveCursor(dr, dc) {
    let newRow = Math.min(rows - 1, Math.max(0, cursorRow + dr));
    let newCol = Math.min(COLS - 1, Math.max(0, cursorCol + dc));
    if (newRow === cursorRow && newCol === cursorCol) return;

    let prevRow = cursorRow;
    let prevCol = cursorCol;
    cursorRow = newRow;
    cursorCol = newCol;
    refreshCursorVisual(prevRow, prevCol);
  }

  function markCurrent() {
    let key = cursorRow + "-" + cursorCol;
    let cellB = byteCellsB[cursorRow][cursorCol];
    let cellA = byteCellsA[cursorRow][cursorCol];

    if (diffSet.has(key)) {
      if (foundSet.has(key)) return; // already found, ignore
      foundSet.add(key);
      cellB.classList.add("found");
      cellA.classList.add("found");
      foundTag.textContent = "FOUND " + foundSet.size + "/" + totalDiffs;

      if (foundSet.size >= totalDiffs) {
        endGame(true);
      }
    } else {
      cellB.classList.add("wrong");
      if (lives > 0) {
        lives -= 1;
        strikesTag.textContent = "STRIKES LEFT " + lives;
      } else {
        endGame(false, "lives");
      }
    }
  }

  window.addEventListener("keydown", function (e) {
    // Space / Enter on an overlay: start or replay
    if (e.key === " " || e.key === "Enter" || e.key === "Spacebar") {
      if (!running) {
        if (!splashScreen.classList.contains("hidden") ||
            !winScreen.classList.contains("hidden") ||
            !loseScreen.classList.contains("hidden")) {
          if (e.repeat) return;
          e.preventDefault();
          resetGame();
          return;
        }
        return;
      }
      // Enter while running: mark the current byte
      if (e.key === "Enter") {
        if (e.repeat) return;
        e.preventDefault();
        markCurrent();
      }
      return;
    }

    if (!running) return;
    if (e.repeat) return;

    switch (e.key) {
      case "ArrowUp":
        moveCursor(-1, 0);
        e.preventDefault();
        break;
      case "ArrowDown":
        moveCursor(1, 0);
        e.preventDefault();
        break;
      case "ArrowLeft":
        moveCursor(0, -1);
        e.preventDefault();
        break;
      case "ArrowRight":
        moveCursor(0, 1);
        e.preventDefault();
        break;
    }
  });

  // ---------- buttons ----------
  startBtn.addEventListener("click", resetGame);
  winRetryBtn.addEventListener("click", resetGame);
  loseRetryBtn.addEventListener("click", resetGame);

  // ---------- initial paint ----------
  updateRoundTimeLabel();
  updateRowsLabel();
  updateDiffsLabel();
  updateLivesLabel();
  foundTag.textContent = "FOUND 0/" + diffsSlider.value;
  strikesTag.textContent = "STRIKES LEFT " + livesSlider.value;
  ttlTag.textContent = "TTL " + formatTime(parseInt(roundTimeSlider.value, 10) * 1000);
})();
